import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../../../http.service';
import { DatePipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from  '@angular/forms';
import { Router } from  '@angular/router';
import { ShareddataService } from '../../../shareddata.service';
import { NotificationService } from '../../../notification.service';
import { NgEventBus } from 'ng-event-bus';

declare var $: any;


@Component({
  selector: 'app-giftcard',
  templateUrl: './giftcard.component.html',
  styleUrls: ['./giftcard.component.css'],
   providers: [DatePipe]
})
export class GiftcardComponent implements OnInit {

 user_detail : any =[]; 

	checkOutForm: FormGroup;
	tip_amount : any='';	
	selected_tip_percentage : any='';
	isSubmitted  =  false;
	deliveryamount: any = 0
	showCompleteOrderButton: any = 0
	payment_via: any = 'giftcardf4'

	showGiftCardLink:any='0';
	checkOutSpin:any=0;
	checkOutData : any =[];
	cartTotalBalance : any =0.00;
	selectedFrancais: any =0;
	francaisData : any =[];
	francaisTax : any =[];
	grandTotalwithTax:any=0.00;
	grandTotalwithTaxTemp: any = 0
	discountAmount: any = 0
	enable_factor4: any ='0'
	loyalityrewardamount: any ='0'
	giftcard_amount: any ='0'

	is_surcharge_enabled='0';
	surcharge_amount='';
	surcharge_label='';
	
	monthDropDownValues : any =[];
	yearDropDownValues : any =[];
	mytime: any = new Date();
	thisYear : any = this.datePipe.transform(this.mytime, 'YY');
	payment_id:any;
	cardErrorApiCall:any ='';
	bookOrderApiMessage : any ='';
	bookOrderResponse :any =[]; 
	selectedFrancaisData :any =[]; 
	deliveryAddressSaved :any =[]; 
	service_type : String ='';
	lat : Number =0.00;
	lng : Number =0.00;

	myCartDateTime: any;
	constructor(
	private _http: HttpService,private datePipe : DatePipe,
	private formBuilder: FormBuilder,
	public router: Router,
	private sharedService: ShareddataService,
	private notifyService : NotificationService,
	private eventBus: NgEventBus

	){
		var location_to_checkout =localStorage.getItem('location_to_checkout');
		if (location_to_checkout==='1') {
			localStorage.removeItem('location_to_checkout');
		} else {
			//window.location.href="/";
		}
	}

  ngOnInit(): void {
  /* 
 localStorage.setItem('location_to_checkout', '1');
	this.router.navigateByUrl('/checkout');  */
	this.service_type=localStorage.getItem('selectedOrderService');
	if(this.service_type==='Delivery') {
		this.checkOutForm  =  this.formBuilder.group({
			first_name: ['', Validators.required],
			last_name: [''],
			card_number: ['', Validators.required],
			card_cvv: [''],
			postalCode: ['', Validators.required],
			state: ['', Validators.required],
			streetaddress: ['', Validators.required],
			city: ['', Validators.required],
			expiryMonth: ['', Validators.required],
			expiryYear: ['', Validators.required],
			//address: ['', Validators.required],
			deliveryinstruction: [''],
		});
		this.serviceTypeDeliveryProcessed();
	} else {
		$( "#different-billing" ).prop( "checked", true );

		this.checkOutForm  =  this.formBuilder.group({
			first_name: ['', Validators.required],
			last_name: [''],
			card_number: ['', Validators.required],
			card_cvv: [''],
			postalCode: ['', Validators.required],
			state: ['', Validators.required],
			streetaddress: ['', Validators.required],
			city: ['', Validators.required],
			expiryMonth: ['', Validators.required],
			expiryYear: ['', Validators.required],
		});  

	}
	
	this.orderDateTime();
	
	this.loadCarddiv();
	
	
	//added the month dropdown value
	this.monthDropDownValues=[];
	for(var i=12;i>=1;i--){
		this.monthDropDownValues.push(i);
	}
	
	//added the month dropdown value
	this.yearDropDownValues=[];
	var startYear=parseInt(this.thisYear);
	for(var j=startYear;j<startYear+10;j++){
		this.yearDropDownValues.push(j);
	}
	
	this.sharedService.sharedOrderDateTime.subscribe((response: any) => {
		this.orderDateTime();
	});	
	this.serverCalApiCall();
	this.eventBus.on('error:delivery').subscribe((meta:any) => {
		this.service_type = '';
		
    });
	this.eventBus.on('server:cal').subscribe((meta:any) => {
		if (localStorage.getItem('selectedOrderService') === 'Curbside' || localStorage.getItem('selectedOrderService') ==='Carry Out') {
			this.service_type = localStorage.getItem('selectedOrderService');
		}
		this.serverCalApiCall();
	});
	//Adding the user name 
	if(localStorage.getItem('user_detail')!=null) {
		this.user_detail= JSON.parse(localStorage.getItem('user_detail'));
		var name = this.user_detail.fullname;
		if (name!='') {
			name = name.split(' ');
			
			var firstName = '';
			var lastName = '';
			
			if (name.length==3) {
				firstName = name[0]+' '+name[1];
				lastName = name[2];
			}
			if (name.length==2) {
				firstName = name[0];
				lastName = name[1];
			}
			if (name.length==1) {
				firstName = name[0];
			}
			if (name.length>3) {
				firstName = name[0]+' '+name[1];
				lastName = name[2];
			}
			this.checkOutForm.patchValue (
				{
					first_name:firstName, 
					last_name:lastName, 
				}
			);
		}
	   
	}
	if(localStorage.getItem('restaurant')!=null) {
		var restaurantlocal = JSON.parse(localStorage.getItem('restaurant'));
		this.showGiftCardLink =  restaurantlocal.enable_gift_card;
		this.enable_factor4 =  restaurantlocal.enable_factor4;

	}
	

  }
   
	  paymentViaSet (value:any) {
		if (value ==='giftcardf4') {
			this.checkOutForm.controls['expiryMonth'].clearValidators();
			this.checkOutForm.controls['expiryYear'].clearValidators();
			
			this.router.navigateByUrl('/gift-card-payment');
		} else {
			this.checkOutForm.controls['expiryMonth'].setValidators([Validators.required]);
			this.checkOutForm.controls['expiryYear'].setValidators([Validators.required]);
			localStorage.setItem('location_to_checkout', '1');
			this.router.navigateByUrl('/checkout');
		}
	    this.checkOutForm.controls['expiryMonth'].updateValueAndValidity();
	    this.checkOutForm.controls['expiryYear'].updateValueAndValidity();

		
		this.payment_via = value;
	 }
     serverCalApiCall () {
		var orderData=localStorage.getItem('orderData');
		if(orderData!=null){
			this.checkOutData=JSON.parse(orderData);
			this.cartTotalBalance=this.getTotalCartAmount(this.checkOutData);
			this.grandTotalwithTax=this.cartTotalBalance;
		}
		if(localStorage.getItem('francais_id')!=null){
			this.selectedFrancais=parseInt(localStorage.getItem('francais_id'));
		}
	
		var selectedOrderService=localStorage.getItem('selectedOrderService');
		this.selected_tip_percentage=localStorage.getItem('selected_tip_percentage');

		var promoData = JSON.parse(localStorage.getItem('promoData'));
		var isPromoApplied=localStorage.getItem('isPromoApplied');
		
		var iscouponApplied=localStorage.getItem('iscouponApplied');
		let couponData=JSON.parse(localStorage.getItem('couponData'));
		
		const server_cal_object = new FormData();

		server_cal_object.append( 'res_id', '49');
		server_cal_object.append( 'subtotal', this.cartTotalBalance);
		
		if (this.selectedFrancais>0) {
			server_cal_object.append( 'franchise_id', this.selectedFrancais);
		}
		if (this.selected_tip_percentage>0) {
			server_cal_object.append( 'selected_tip_percentage', this.selected_tip_percentage);
		}
		if (iscouponApplied!=null && iscouponApplied==='1' && couponData!=null) {
			console.log(couponData);
			var couponId = couponData.id;
			server_cal_object.append( 'couponid', couponId);
		}
		
		if (isPromoApplied!=null && isPromoApplied==='1' && promoData!=null) {
			var promoid = promoData.id;
			server_cal_object.append( 'promoid', promoid);
		}
		
		server_cal_object.append( 'service_type', selectedOrderService);
		this.discountAmount = 0.00;
		this.deliveryamount = 0.00;
		this._http.postRequest('server_side_taxcal.php',server_cal_object).subscribe((data: any) => {
			if (data.error_type) {
				if (data.error_type==='other') {
					this.notifyService.showError(data.message, "Error ..!!");
					localStorage.removeItem('promoData');
					localStorage.removeItem('isPromoApplied');
					localStorage.removeItem('iscouponApplied');
					localStorage.removeItem('couponData');
					this.serverCalApiCall();
					return false;
				}
			}
			if (data.data.totalamount) {
				this.grandTotalwithTax = data.data.totalamount;
			}
			if (data.data.taxesdata) {
				this.francaisTax = data.data.taxesdata;
			}
			if (data.data.discountamount) {
				this.discountAmount = data.data.discountamount;
			}
			if (data.data.deliveryamount) {
				this.deliveryamount = data.data.deliveryamount;
			}
			if (data.data.tip_amount) {
				this.tip_amount = data.data.tip_amount;
			}
			if (data.data.is_surcharge_enabled==="1") {
				this.is_surcharge_enabled=data.data.is_surcharge_enabled;
				this.surcharge_amount=data.data.surcharge_amount;
				this.surcharge_label=data.data.surcharge_label;
			}
			
			this.checkingloyalityreward();
				
		}); 
	}


   handleAddressChange(address) {
		this.lat=address.geometry.location.lat();
		this.lng=address.geometry.location.lng();

    }
	orderDateTime () {
		if(localStorage.getItem("orderDatetime")!=null){
			this.mytime=localStorage.getItem("orderDatetime");
			var orderTime = this.datePipe.transform(this.mytime, 'h:mm a');
			var orderDate = this.datePipe.transform(localStorage.getItem("orderDate"), 'EEEE, MMMM d');
			this.myCartDateTime=orderDate+' '+orderTime;
		}else{
			this.myCartDateTime=this.datePipe.transform(this.mytime, 'EEEE, MMMM d h:mm a');
		}
	}	
  
  
	getTotalCartAmount(cartData){
		var total_amount=0;
		for (var i=0;i<cartData.length;i++){
			total_amount=total_amount+cartData[i].ItemAmt;
		}
		return total_amount;		
	}
  
	loadCarddiv(){
		

	}
  
	get formControls() { return this.checkOutForm.controls; }

    checkOutProccess(){
		this.isSubmitted = true;
		if(this.checkOutForm.invalid){
		  return;
		}
		this.checkOutSpin=1;
		var userData=JSON.parse(localStorage.getItem('user_detail'));
		const doTranscation = new FormData();
	
	}
  
	
  
	
	
	
	differentBillingChange(event) {
		if (event.currentTarget.checked) {
			this.lat=0;
			this.lng=0;
			this.checkOutForm.patchValue({streetaddress:''});
			this.checkOutForm.patchValue({city:''});
			this.checkOutForm.patchValue({state:''});
		  } else {
			this.serviceTypeDeliveryProcessed();
		  }
	}
	serviceTypeDeliveryProcessed () {
		if(localStorage.getItem('deliveryAddress')!=null){
			var deliveryAddress=JSON.parse(localStorage.getItem('deliveryAddress'));
			this.deliveryAddressSaved = deliveryAddress;
			for (var i=0;i<deliveryAddress.length;i++) {
				 if(deliveryAddress[i].lat && deliveryAddress[i].lat!='') {
				    this.lat=deliveryAddress[i].lat;
				 } if(deliveryAddress[i].lng && deliveryAddress[i].lng!='') {
				    this.lng=deliveryAddress[i].lng;
				 } if(deliveryAddress[i].fulladdress) {
					this.checkOutForm.patchValue({streetaddress:deliveryAddress[i].fulladdress});
				}if(deliveryAddress[i].city) {
					this.checkOutForm.patchValue({city:deliveryAddress[i].city});
				}if(deliveryAddress[i].state) {
					this.checkOutForm.patchValue({state:deliveryAddress[i].state});
				}
			}
		}
	}
		
	pizaToppingPriceCart (cartData:any, addOn:any)
	{
		var topingamt = addOn.pizaextra_price;
		topingamt = topingamt*cartData.ItemQty;
		return topingamt.toFixed(2);
	}
	
	checkingloyalityreward () {
		var account_number = localStorage.getItem('account_number');
		this.loyalityrewardamount = localStorage.getItem('loyalityrewardamount');
		this.giftcard_amount = localStorage.getItem('giftcard_amount');
		var  giftcard_apply = localStorage.getItem('giftcard_apply');
		var loyalityapply = localStorage.getItem('loyalityapply');
		
		if (loyalityapply==='1' && this.loyalityrewardamount>=this.grandTotalwithTax) {
			this.showCompleteOrderButton = '1';
			$('.left-div').show();
			$('.completediv').show();
			//this.checkOutSpin = 1;
		
			
		} else {
			this.showCompleteOrderButton = '0';
			
			$('.left-div').show();
		}
		if (this.loyalityrewardamount==null) {
			this.loyalityrewardamount = 0;
		}
		
		if (this.giftcard_amount==null) {
			this.giftcard_amount = 0;
		}
	}
	
	verfiyAccount () 
	{
		var account_number = $('#account_number').val();
		var password_account = $('#pin').val();
		if (account_number==='') {
			this.cardErrorApiCall='Please fill  Account # fields first.';
			return ;
		}
		var loyalty_account_id= localStorage.getItem('account_number');
		
		if (loyalty_account_id===account_number) {
		
			this.cardErrorApiCall='You can not use the same Account # for loyalty and gift card.';
		
			return ;
		}
		
		const giftCard = new FormData();
		giftCard.append('account_number', account_number);
		giftCard.append('password_account', password_account);
		$('#loyalityreward').modal('hide');
		
		localStorage.removeItem('giftcard_account_id');
		localStorage.removeItem('giftcard_amount');
		localStorage.removeItem('giftcard_pin');
		localStorage.removeItem('giftcard_apply');
		this.giftcard_amount = 0;
		this.cardErrorApiCall = 0;
		
		this.showCompleteOrderButton = '0';
		var totalAmount = this.grandTotalwithTax-this.loyalityrewardamount;
		
		this._http.postRequest('loyaltyredemption.php',giftCard).subscribe((reponse : any)=>{
			if (reponse.success==1) {
				if (reponse.amount>0) {
					
					if (reponse.amount>=totalAmount) {
						this.giftcard_amount = totalAmount;
					} else {
						this.giftcard_amount =parseFloat(reponse.amount);
					}
					if (confirm("Would you like to apply your GiftCard Dollars of "+this.giftcard_amount.toFixed(2)+" to the order?")) {
						
						localStorage.setItem('giftcard_account_id', account_number);
						localStorage.setItem('giftcard_pin', password_account);
						localStorage.setItem('giftcard_amount', this.giftcard_amount.toFixed(2));
						localStorage.setItem('giftcard_apply', '1');
						localStorage.setItem('location_to_checkout', '1');
						this.router.navigateByUrl('/checkout');
			
					} else {
						this.giftcard_amount = 0;
					}
					
				} else {
					localStorage.setItem('giftcard_apply', '0');

					alert("Not found any amount in your card.");
				}
			} else if (reponse.success==0) {
				alert(reponse.message);

			}
		});

	}

}
